import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  root: {
    backgroundColor: "white",
    textAlign: "center",
  },
  item: {
    paddingTop: "15px",
    paddingBottom: "15px",
    paddingRight: "15px",
  },
  item2: {
    width: "100%",
    height: "0",
  },
  main: {
    paddingTop: "15px",
    paddingBottom: "15px",
  },
  auth: {
    paddingBottom: "60px",
    paddingTop: "30px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  topBar: {
    height: "3px",
    backgroundColor: "#1B72CE",
    width: "100%",
  },
  margin: {
    padding: "20px 0",
  },
  paddingBottom: {
    paddingBottom: "10px",
  },
  paddingRight: {
    paddingRight: "7px",
  },
});
